import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel,
    IconButton, Box,
    CircularProgress
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';

const ClothReturnEntry = () => {
    const { Id } = useParams();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        edt: getCurrentDate(),
        userId: userdata?.ID
    });
    const [clothData, setClothData] = useState({});
    const [cuttingData, setCuttingData] = useState({});
    const [clothIssData, setClothIssData] = useState([]);
    const [lumpData, setLumpData] = useState([]);
    const [usedData, setUsedData] = useState([]);
    const [lumpView, setLumpView] = useState([]);
    const [clothUsemtr, setClothUsemtr] = useState([]);

    const [totUsemtr, setTotUsemtr] = useState({
        mused: '0',
        m1used: '0',
        m2used: '0',
        m3used: '0'
    });

    const [loading, setLoading] = useState(false);
    // console.log(cuttingData, clothIssData);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    useEffect(() => {
        if (Id) {
            fetchCuttingData(Id);
        }
    }, [Id]);

    useEffect(() => {
        if (cuttingData?.data) {
            const value = cuttingData.data;
            setFormData(prev => ({
                ...prev,
                ...cuttingData.data
            }))

            setClothData(cuttingData?.cloth_data || {});
            setClothIssData(cuttingData?.cloth_issue_data?.bale_data)
        }
    }, [cuttingData]);

    useEffect(() => {
        if (clothUsemtr.length > 0 && clothData) {
            const mcloth = clothData?.mcloth;
            const m1cloth = clothData?.m1cloth;
            const m2cloth = clothData?.m2cloth;
            const m3cloth = clothData?.m3cloth;

            const mused = getUsermtr(mcloth);
            const m1used = getUsermtr(m1cloth);
            const m2used = getUsermtr(m2cloth);
            const m3used = getUsermtr(m3cloth);

            setTotUsemtr({
                mused: mused,
                m1used: m1used,
                m2used: m2used,
                m3used: m3used
            });
        }
    }, [clothUsemtr, clothData]);


    const fetchCuttingData = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getClothDetailsFromclothIssue&ctId=${id}`);
            setCuttingData(res.data);
        } catch (error) {
            console.log(error);
        };
    };

    const fetchLumpData = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=cloth_issue_Lump_data_usingbaleId&infoId=${id}`);
            // console.log(res.data);
            setLumpData(res.data?.data);
        } catch (error) {
            console.log(error);
        };
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        switch (dropdownType) {

            default:
                break;
        }
    };

    const handleAddLumps = () => {
        if (formData.bale !== "") {
            fetchLumpData(formData.bale);
        } else {
            alert('select Bale');
        }
    };
    const filteredBaleOptions = React.useMemo(() => {

        return clothIssData?.filter(
            item => !usedData.some(
                used => used.ID === item.ID
            )
        ) || [];

    }, [clothIssData, usedData]);

    const dropdownlistfirst = [
        {
            label: 'Bale',
            id: 'bale',
            options: filteredBaleOptions || [],
            value: formData.bale,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'bale', value: newValue ? newValue.ID : '' } }, 'bale'),
            getOptionLabel: (option) => ` ${option.baleNo}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleAddLumps(),
            btnlabel: 'Add',
            btndisabled: lumpData.length > 0
        }
    ];

    const handleLumpSelection = (index) => {
        const newRows = [...lumpData];
        newRows[index].selected = !newRows[index].selected;
        setLumpData(newRows);
    };

    const handleLumpMtr = (index, value) => {

        const updateLumps = [...lumpData];

        const bmtr = Number(updateLumps[index].bmtr) || 0;
        let usemtr = Number(value) || 0;

        // Prevent issue meter greater than available meter
        if (usemtr > bmtr) {
            alert("Issue meter cannot be greater than available meter");
            usemtr = 0;
        }

        // Prevent negative
        if (usemtr < 0) {
            usemtr = 0;
        }

        updateLumps[index].usemtr = usemtr;

        const remtr = bmtr - usemtr;

        updateLumps[index].loose = remtr > 0 ? '1' : '0';

        updateLumps[index].balmtr = remtr;

        setLumpData(updateLumps);

    };

    const handleBalMtr = (index, value) => {

        const updateLumps = [...lumpData];

        const bmtr = Number(updateLumps[index].bmtr) || 0;
        let balmtr = Number(value) || 0;

        // Prevent balance greater than available
        if (balmtr > bmtr) {
            alert("Balance meter cannot be greater than available meter");
            balmtr = 0;
        }

        // Prevent negative
        if (balmtr < 0) {
            balmtr = 0;
        }

        // Calculate usemtr
        const usemtr = bmtr - balmtr;

        updateLumps[index].balmtr = balmtr;
        updateLumps[index].usemtr = usemtr;

        // Loose logic
        updateLumps[index].loose = balmtr > 0 ? '1' : '0';

        setLumpData(updateLumps);

    };

    const handleAddLumpUsed = () => {

        const selectBaleData = clothIssData?.find(
            i => i.ID === formData.bale
        );

        if (!selectBaleData) {
            alert("Please select bale");
            return;
        }

        // Prevent duplicate bale
        const alreadyExists = usedData.some(
            item => item.ID === selectBaleData.ID
        );

        if (alreadyExists) {
            alert("This bale already added");
            return;
        }

        const usemtr = (lumpData?.reduce((a, s) => a + Number(s.usemtr || 0), 0)).toFixed(2);
        const balmtr = (lumpData?.reduce((a, s) => a + Number(s.balmtr || 0), 0)).toFixed(2);

        const data = {
            ID: selectBaleData.ID,
            baleId: selectBaleData.baleId,
            baleNo: selectBaleData.baleNo,
            baleMtr: selectBaleData.baleMtr,
            clothId: selectBaleData.clothId,
            clothNm: selectBaleData.clothNm,
            gMtr: selectBaleData.gMtr,
            stkId: selectBaleData.stkId,
            usemtr: usemtr,
            balmtr: balmtr,
            returnType: '',
            rate: '',
            isSelected: false,
            // clone array (VERY IMPORTANT)
            lumpdata: JSON.parse(JSON.stringify(lumpData))
        };

        const clothusemtr = {
            clothId: selectBaleData.clothId,
            usemtr: usemtr
        };
        setClothUsemtr(prev => [...prev, clothusemtr]);

        setUsedData(prev => [...prev, data]);

        // // remove selected bale from clothIssData
        // setClothIssData(prev =>
        //     prev.filter(item => item.ID !== formData.bale)
        // );
        setLumpData([]);
        setFormData(prev => ({
            ...prev,
            bale: ''
        }));
    };

    const handleReturnTypeChange = (index, value) => {

        const updatedData = [...usedData];

        updatedData[index].returnType = value;

        // reset rate if not Settlement
        if (value !== "Settlement") {
            updatedData[index].rate = "";
        }

        setUsedData(updatedData);
    };

    const handleRateChange = (index, value) => {

        const updatedData = [...usedData];

        updatedData[index].rate = value;

        setUsedData(updatedData);
    };

    const handleCheckboxChange = (index, checked) => {

        const updatedData = [...usedData];

        updatedData[index].isSelected = checked;
        // console.log(updatedData);
        setUsedData(updatedData);

    };

    const handleRemoveSelected = () => {
        const removingData = usedData.filter(i => i.isSelected);
        const filteredData = usedData.filter(i => !i.isSelected);
        setUsedData(filteredData);
        // console.log(removingData);

    };

    const isAnyRowSelected = usedData.some(i => i.isSelected);

    const getUsermtr = (id) => {
        const selectcloths = clothUsemtr?.filter(i => i.clothId === id) || [];
        const totmtr = selectcloths?.reduce((a, s) => a + Number(s.usemtr || 0), 0) || 0;
        return totmtr
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const postObj = (formData, Id, usedData, totUsemtr) => {
        const data = {
            edt: formData.edt,
            ctId: Id,
            soId: formData.soId,
            usedData: usedData,
            empId: formData.empId,
            userId: formData.userId,
            itemId: formData.itemId,
            clothData: totUsemtr
        };
        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Find invalid rows
        const invalidRows = usedData.filter(
            row => Number(row.balmtr) > 0 && !row.returnType
        );

        if (invalidRows.length > 0) {

            alert("Please select Return Type for all Balance Mtr rows");

            return;
        }


        // Optional: Settlement rate validation
        const invalidRateRows = usedData.filter(
            row =>
                row.returnType === "Settlement" &&
                (row.rate === undefined || row.rate === "" || Number(row.rate) <= 0)
        );

        if (invalidRateRows.length > 0) {

            alert("Please enter rate for Settlement rows");

            return;
        }

        try {
            setLoading(true);
            const postdata = postObj(formData, Id, usedData, totUsemtr);
            // ✅ Your original submit code here
            // console.log("post Data:", postdata);
            const res = await axios.post(`${baseUrl}?apicall=insertCuttingClothReturnEntry`, postdata);
            const data = res.data;
            // console.log(data);
            if (data.status === "success") {
                alert(data.msg);
                window.opener.postMessage("REFRESH_PARENT", "*");
                window.close();
            } else {
                const msg = Array.isArray(data.msg) ? data.msg.join("\n") : data.msg;
                alert(msg);
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setLoading(false);
        }


    };

    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2 className='centered-heading'>Cloth Use/Return Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            {cuttingData?.data ?
                                <Grid container spacing={0.5}>

                                    <div className="dashed-line"></div>

                                    <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: '200px' }}>Date</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>
                                                    <TextField
                                                        id='edt'
                                                        name='edt'
                                                        type="date"
                                                        value={formData.edt}
                                                        onChange={(e) => handleDateChange(e)}
                                                        inputProps={{ style: styled.cutDate }}
                                                        sx={inputStyles}
                                                    />
                                                </td>

                                                <td style={{ width: '200px' }}>Cutting Memo No.</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.ctMemo}</td>

                                            </tr>
                                            <tr>
                                                <td style={{ width: '200px' }}>Firm</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.firmNm}</td>

                                                <td style={{ width: '200px' }}>Party</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.partyNm}</td>

                                            </tr>

                                            <tr>
                                                <td style={{ width: '200px' }}>SO No</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>
                                                <td style={{ width: '200px' }}>Master</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>

                                            </tr>

                                            <tr>
                                                <td style={{ width: '200px' }}>Item</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>
                                                <td style={{ width: '200px' }}>Main Cloth</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }}>
                                                    {clothData?.mclothNm} <br />
                                                    {`Given Mtr/KG : ${clothData?.mgmtr}`} <br />
                                                    {`Req Mtr/KG : ${clothData?.mreq}`} <br />
                                                    {`Used Mtr/KG: ${totUsemtr.mused}`}
                                                </td>
                                            </tr>


                                            <tr>
                                                {clothData?.m1cloth !== '0' && <td style={{ width: '200px' }}>Match-1 Cloth</td>}
                                                {clothData?.m1cloth !== '0' && <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }}>
                                                    {clothData?.m1clothNm}
                                                    <br />
                                                    {`Given Mtr/KG : ${clothData?.m1gmtr}`} <br />
                                                    {`Req Mtr/KG : ${clothData?.m1req}`} <br />
                                                    {`Used Mtr/KG: ${totUsemtr.m1used}`}
                                                </td>}
                                                {clothData?.m2cloth !== '0' && <td style={{ width: '200px' }}>Match-2 Cloth</td>}
                                                {clothData?.m2cloth !== '0' && <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }}>
                                                    {clothData?.m2clothNm}<br />
                                                    {`Given Mtr/KG : ${clothData?.m2gmtr}`} <br />
                                                    {`Req Mtr/KG : ${clothData?.m2req}`} <br />
                                                    {`Used Mtr/KG: ${totUsemtr.m2used}`}

                                                </td>}
                                            </tr>

                                            {clothData?.m3cloth !== '0' && <tr>
                                                <td style={{ width: '200px' }}>Match-3 Cloth</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }}>
                                                    {clothData?.mclothNm}<br />
                                                    {`Given Mtr/KG : ${clothData?.m3gmtr}`} <br />
                                                    {`Req Mtr/KG : ${clothData?.m3req}`} <br />
                                                    {`Used Mtr/KG: ${totUsemtr.m3used}`}
                                                </td>
                                            </tr>}
                                        </tbody>
                                    </table>

                                    <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                        <thead>
                                            <th>Cloth</th>
                                            <th>Bale</th>
                                            <th>Bale Mtr/KG</th>
                                            <th>Given Mtr/KG</th>
                                        </thead>
                                        <tbody>
                                            {
                                                Array.isArray(clothIssData) && clothIssData?.map((i, dx) => (
                                                    <tr key={dx}>
                                                        <td>{i.clothNm}</td>
                                                        <td>{i.baleNo}</td>
                                                        <td>{i.baleMtr}</td>
                                                        <td>{i.gMtr}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>

                                    {
                                        dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                            <DropdownWithBtn
                                                key={drop.label}
                                                label={drop.label}
                                                id={drop.id}
                                                options={drop.options}
                                                value={drop.value}
                                                onChange={drop.onChange}
                                                isDesktop={isDesktop}
                                                getOptionLabel={drop.getOptionLabel}
                                                isOptionEqualToValue={drop.isOptionEqualToValue}
                                                valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                                handleAddNew={drop.handleAddNew}
                                                btnlabel={drop.btnlabel}
                                                btndisabled={drop.btndisabled}
                                            />
                                        ))
                                    }
                                    <Grid item xs={12} md={6}>

                                    </Grid>

                                    {Array.isArray(lumpData) && lumpData.length > 0 &&
                                        <Grid item xs={12} md={12}>
                                            <h3>Lump Details </h3>

                                            <table style={{ width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Sr. No.</th>
                                                        <th>Barcode</th>
                                                        <th>Color</th>
                                                        <th>Given Mtr/KG</th>
                                                        <th>Used Lump Mtr/KG</th>
                                                        <th>Bal Mtr/KG</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {lumpData?.map((lumpRow, lumpIndex) => (
                                                        <>
                                                            <tr key={lumpIndex}>
                                                                <td>
                                                                    {/* <input
                                                                    type="checkbox"
                                                                    checked={lumpRow.selected}
                                                                    onChange={() => handleLumpSelection(lumpIndex)}
                                                                />{" "} */}
                                                                    {lumpIndex + 1}
                                                                </td>
                                                                <td>
                                                                    {lumpRow.barcd}
                                                                </td>
                                                                <td>
                                                                    {lumpRow.color}
                                                                </td>
                                                                <td>
                                                                    {lumpRow.bmtr}

                                                                </td>
                                                                <td>
                                                                    {/* {lumpRow.loose === '1' && <span>Loose -</span>} */}
                                                                    <input
                                                                        type="number"
                                                                        placeholder="Lump Mtr"
                                                                        value={lumpRow.usemtr}
                                                                        onChange={(e) => handleLumpMtr(
                                                                            lumpIndex,
                                                                            e.target.value
                                                                        )}
                                                                    // readOnly
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        placeholder="Bal Mtr"
                                                                        value={lumpRow.balmtr}
                                                                        onChange={(e) =>
                                                                            handleBalMtr(
                                                                                lumpIndex,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ))}
                                                    <tr style={{ color: 'blue', fontWeight: 'bolder', fontSize: '15px' }}>
                                                        <td colSpan={3}>Total</td>
                                                        <td>{(lumpData?.reduce((a, s) => a + Number(s.bmtr), 0)).toFixed(2)}</td>
                                                        <td>{(lumpData?.reduce((a, s) => a + Number(s.usemtr), 0)).toFixed(2)}</td>
                                                        <td>{(lumpData?.reduce((a, s) => a + Number(s.balmtr), 0)).toFixed(2)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="button-group">
                                                <button className="add" onClick={handleAddLumpUsed}>Add Lump</button>
                                            </div>

                                        </Grid>
                                    }

                                    {Array.isArray(usedData) && usedData.length > 0 &&
                                        <Grid item xs={12} md={12}>
                                            <h3>Exact Used Mtr/KG</h3>

                                            {isAnyRowSelected &&
                                                <button className="add" onClick={handleRemoveSelected}>
                                                    Remove
                                                </button>
                                            }


                                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                                <thead>
                                                    <th>Select</th>
                                                    <th>Cloth</th>
                                                    <th>Bale</th>
                                                    <th>Bale Mtr/KG</th>
                                                    <th>Given Mtr/KG</th>
                                                    <th>Used Mtr/KG</th>
                                                    <th>Bal Mtr/KG</th>
                                                    <th>Lump View</th>
                                                </thead>
                                                <tbody>
                                                    {
                                                        Array.isArray(usedData) && usedData?.map((i, dx) => (
                                                            <tr key={dx}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={i.isSelected || false}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange(dx, e.target.checked)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>{i.clothNm}</td>
                                                                <td>{i.baleNo}</td>
                                                                <td>{i.baleMtr}</td>
                                                                <td>{i.gMtr}</td>
                                                                <td>{i.usemtr}</td>
                                                                <td>

                                                                    {i.balmtr}

                                                                    {i.balmtr > 0 && (
                                                                        <>
                                                                            <br />

                                                                            <select
                                                                                value={i.returnType || ""}
                                                                                onChange={(e) =>
                                                                                    handleReturnTypeChange(dx, e.target.value)
                                                                                }
                                                                            >

                                                                                <option value="">Select Option</option>

                                                                                <option value="Return">Return</option>

                                                                                <option value="Settlement">Settlement</option>

                                                                                <option value="Carry Forward">Carry Forward</option>

                                                                            </select>


                                                                            {/* Show Rate input if Settlement */}
                                                                            {i.returnType === "Settlement" && (

                                                                                <>
                                                                                    <br />

                                                                                    <input
                                                                                        type="number"
                                                                                        placeholder="Enter Rate"
                                                                                        value={i.rate || ""}
                                                                                        onChange={(e) =>
                                                                                            handleRateChange(dx, e.target.value)
                                                                                        }
                                                                                        style={{ width: "100px", marginTop: "5px" }}
                                                                                    />

                                                                                </>

                                                                            )}

                                                                        </>
                                                                    )}

                                                                </td>
                                                                <td><button className="add" onClick={() => setLumpView(i.lumpdata)}>Lump</button></td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </Grid>
                                    }

                                    {Array.isArray(lumpView) && lumpView.length > 0 &&
                                        <Grid item xs={12} md={6} style={{ position: 'relative' }}>

                                            {/* Header with Close Button */}
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>

                                                <h3 style={{ margin: 0 }}>Lump Details</h3>

                                                <IconButton
                                                    size="small"
                                                    onClick={() => setLumpView([])} // close action
                                                >
                                                    <CloseIcon />
                                                </IconButton>

                                            </div>

                                            {/* Table */}
                                            <table style={{ width: '100%', marginTop: '10px' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Sr. No.</th>
                                                        <th>Barcode</th>
                                                        <th>Color</th>
                                                        <th>Given Mtr/KG</th>
                                                        <th>Used Lump Mtr/KG</th>
                                                        <th>Bal Mtr/KG</th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {lumpView.map((lumpRow, lumpIndex) => (

                                                        <tr key={lumpIndex}>
                                                            <td>{lumpIndex + 1}</td>
                                                            <td>{lumpRow.barcd}</td>
                                                            <td>{lumpRow.color}</td>
                                                            <td>{lumpRow.bmtr}</td>
                                                            <td>{lumpRow.usemtr}</td>
                                                            <td>{lumpRow.balmtr}</td>
                                                        </tr>

                                                    ))}

                                                    <tr style={{
                                                        color: 'blue',
                                                        fontWeight: 'bold',
                                                        fontSize: '15px'
                                                    }}>
                                                        <td colSpan={3}>Total</td>

                                                        <td>
                                                            {lumpView.reduce((a, s) => a + Number(s.bmtr), 0).toFixed(2)}
                                                        </td>

                                                        <td>
                                                            {lumpView.reduce((a, s) => a + Number(s.usemtr), 0).toFixed(2)}
                                                        </td>

                                                        <td>
                                                            {lumpView.reduce((a, s) => a + Number(s.balmtr), 0).toFixed(2)}
                                                        </td>

                                                    </tr>

                                                </tbody>

                                            </table>

                                        </Grid>
                                    }


                                    {usedData?.length > 0 &&
                                        (<Grid item xs={12} textAlign="center">
                                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                                {
                                                    loading === true ?
                                                        <><CircularProgress size="20px" /> wait...</> :
                                                        "Submit"
                                                }
                                            </Button>
                                        </Grid>)}
                                </Grid>
                                :
                                <div>
                                    <p>Loading...</p>
                                </div>
                            }
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ClothReturnEntry;
